'use client'

import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Icon from "@/components/icon/Icon";
import Button from "@/components/button/Button";
import Slideout from "@/components/slideout/Slideout";
import StackedPanel from "@/components/panel/StackedPanel";
import PanelHeader from "@/components/panel/PanelHeader";
import PanelBody from "@/components/panel/PanelBody";
import PanelTitle from "@/components/panel/PanelTitle";
import TradeForm from "../trade/TradeForm";

const TradeSlideButton = forwardRef((props, ref) => {

  const slide = useRef()
  
  const toggle = () => {
    slide.current.toggle()
  }
  
  useImperativeHandle(ref, () => ({
    toggle
  }))
  
  return <>
    { props.children &&
    <Button {...props} onClick={e => toggle(e)}>
      { props.children }
    </Button>
    }
    <Slideout ref={slide}>
      <StackedPanel>
        <PanelHeader>
          <PanelTitle leftPad={true} centered={true}>
            <h2>Value Your Trade</h2>
          </PanelTitle>
          <div>
            <Button theme={'icon'} onClick={e => toggle(e)} label={ 'Close' }>
              <Icon {...props} name="x"></Icon>
            </Button>
          </div>
        </PanelHeader>
        <PanelBody padded={true}>
          <TradeForm {...props} theme="plain" close={e => slide.current.toggle()}></TradeForm>
        </PanelBody>
      </StackedPanel>
    </Slideout>    
  </>

  
})

TradeSlideButton.displayName = "TradeSlideButton"
export default TradeSlideButton